import * as React from "react";
import { Outlet, createRootRoute, redirect } from "@tanstack/react-router";
import { RouteUrl } from "@/configs/router/routes";
import { PageNotFound } from "@/pages/notFound/page";

export const Route = createRootRoute({
    component: RootComponent,
    notFoundComponent: () => <PageNotFound />,
    beforeLoad: ({ location }) => {
        const isHome = location.pathname === RouteUrl.Home;
        const isDashboard = location.pathname === RouteUrl.Dashboard;
        const isTournament = location.pathname === RouteUrl.TournamentAnalysis;
        const isKpi = location.pathname === RouteUrl.Kpis;
        const isSettings = location.pathname === RouteUrl.Settings;

        if (isHome) {
            throw redirect({ to: RouteUrl.Login, replace: true });
        }

        if (isDashboard) {
            throw redirect({ to: RouteUrl.DashboardOverview, replace: true });
        }

        if (isTournament) {
            throw redirect({ to: RouteUrl.TournamentOverview, replace: true });
        }

        if (isKpi) {
            throw redirect({ to: RouteUrl.KpisCurrent, replace: true });
        }

        if (isSettings) {
            throw redirect({ to: RouteUrl.SettingsMultiplier, replace: true });
        }
    },
});

function RootComponent() {
    return (
        <React.Fragment>
            <Outlet />
        </React.Fragment>
    );
}
